// import { Protect } from '@clerk/clerk-react'
import { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { graphql } from 'relay-runtime'
import { useLazyLoadQuery } from 'react-relay'
import { RequestStatus } from '@/defines/requestDefines'
import { useUserStore } from '@/defines/store/userStore'
import type { aiConsultQuery as AiConsultQueryType } from './__generated__/aiConsultQuery.graphql'
import userImage from 'assets/user.png'
import { PaginationData } from '@/defines/commonDefines'
import { useNavigate } from 'react-router-dom'

const AiConsultQuery = graphql`
query aiConsultQuery($recipientid: String!, $queryStart: timestamptz!, $queryEnd: timestamptz!){
  insurance_request_log_connection(where: {recipientid: {_eq: $recipientid}, created_at: {_gte: $queryStart, _lte: $queryEnd}}, order_by: {created_at: asc}) {
    edges {
      node {
        request_ai_consult_details {
          id
          linkparameter
          startchatdate
          created_at
        }
        recipient {
          id
          email
          imageurl
          last_seen
          name
        }
        requeststatus
        requesttype
        recipientid
        insuranceid
        id
        created_at
        caredetailid
        aiconsultdetailid
      }
    }
  }
}
`

interface RequestChatViewModel {
    aiconsultdetailid: number | null | undefined;
    caredetailid: number | null | undefined;
    created_at: Date | null | undefined;
    id: string;
    insuranceid: string;
    recipientid: string | null | undefined;
    request_ai_consult_details: {
        created_at: any;
        id: string;
        linkparameter: string;
        startchatdate: any;
    } | null | undefined;
    recipient: {
        email: string | null | undefined;
        id: string;
        imageurl: string | null | undefined;
        last_seen: any;
        name: string;
    } | null | undefined;
    requeststatus: number;
    requesttype: number;
}

export default function AiConsult() {
    const [paginationData] = useState({} as PaginationData)
    const [data, setData] = useState([] as RequestChatViewModel[]);
    const userId = useUserStore.getState().userData.id;
    const navigate = useNavigate();

    let queryStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    var queryEndDate = new Date(new Date(queryStartDate).setMonth(queryStartDate.getMonth() + 1));

    const aiConsultData = useLazyLoadQuery<AiConsultQueryType>(
        AiConsultQuery,
        {
            recipientid: userId,
            queryStart: queryStartDate.toUTCString(),
            queryEnd: queryEndDate.toUTCString()
        },
    );

    useEffect(() => {
        console.log(aiConsultData);
        if (aiConsultData?.insurance_request_log_connection?.edges.length == 0) {
            return;
        }
        let list = [] as RequestChatViewModel[];
        aiConsultData?.insurance_request_log_connection?.edges.forEach(item => {
            let forAdd = {} as RequestChatViewModel;
            if (item.node.request_ai_consult_details) {
                forAdd.request_ai_consult_details = {
                    created_at: item.node.request_ai_consult_details.created_at,
                    id: item.node.request_ai_consult_details.id,
                    linkparameter: item.node.request_ai_consult_details.linkparameter,
                    startchatdate: item.node.request_ai_consult_details.startchatdate
                };
            }
            if (item.node.recipient) {
                forAdd.recipient = {
                    email: item.node.recipient.email,
                    id: item.node.recipient.id,
                    imageurl: item.node.recipient.imageurl,
                    last_seen: item.node.recipient.last_seen,
                    name: item.node.recipient.name,
                };
            }
            forAdd.id = item.node.id;
            forAdd.aiconsultdetailid = item.node.aiconsultdetailid;
            forAdd.caredetailid = item.node.caredetailid;
            forAdd.created_at = item.node.created_at;
            forAdd.insuranceid = item.node.insuranceid;
            forAdd.recipientid = item.node.recipientid;
            forAdd.requeststatus = item.node.requeststatus;
            forAdd.requesttype = item.node.requesttype;
            list.push(forAdd);
        });
        setData(list);
    }, [aiConsultData])

    const redirectToDetail = (linkparameter: string) => {
        console.log('redirectToDetail', linkparameter);
        navigate(`/patient/ai-consult-detail?linkparameter=${linkparameter}`);
    }

    return (

        <div className="flex justify-center items-center">
            {/* <Protect
                role="org:admin"
                fallback={<p>您並無相關權限</p>}
            > */}

            <div className="bg-white w-full">
                <div>
                    <main className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                        <div className="flex items-baseline justify-between pt-6 pb-3 border-b border-gray-200">
                            <h1 className="text-4xl font-bold tracking-tight text-gray-900">
                                您的AI諮詢
                            </h1>
                        </div>

                        <section
                            aria-labelledby="products-heading"
                            className="pt-1 pb-24"
                        >
                            <div className="flex flex-row">

                                {/* Product grid */}
                                <div className="px-1 py-3 basis-full basis-full">

                                    <InfiniteScroll
                                        dataLength={data.length}
                                        next={() => {
                                            // loadData(true, paginationData.endCursor)
                                        }}
                                        scrollThreshold={'90%'}
                                        hasMore={paginationData.hasNextPage}
                                        loader={<h4>載入中...</h4>}
                                        endMessage={
                                            <p className='mt-12' style={{ textAlign: 'center' }}>
                                                <b>沒有更多資料了 ! </b>
                                            </p>
                                        }
                                    >

                                        {data.map((request) => (
                                            <li key={request.id} className="flex justify-between gap-x-2 py-5 cursor-pointer" onClick={() => { redirectToDetail(request.request_ai_consult_details?.linkparameter!) }}>
                                                <div className="flex min-w-0 gap-x-4">
                                                    <img alt="" src={request.recipient?.imageurl ?? userImage} className="size-12 flex-none rounded-full bg-gray-50" />
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm/6 font-semibold text-gray-900">
                                                            {request.recipient?.name ?? '此連結無使用者'}
                                                        </p>
                                                        <p className="mt-1 flex text-xs/5 text-gray-500">
                                                            {request.recipient?.email ?? ''}
                                                        </p>

                                                        <div className="sm:hidden flex flex-col">
                                                            <p className="mt-1 text-xs/5 text-gray-500">
                                                                狀態: {RequestStatus[request.requeststatus]}
                                                            </p>
                                                            {
                                                                request.created_at ?
                                                                    <p className="mt-1 text-xs/5 text-gray-500">
                                                                        建立時間 {new Date(request.created_at).toLocaleString()}
                                                                    </p>
                                                                    :
                                                                    <></>
                                                            }
                                                            {
                                                                request.request_ai_consult_details?.startchatdate ?
                                                                    <p className="mt-1 text-xs/5 text-gray-500">
                                                                        開始使用時間 {new Date(request.request_ai_consult_details?.startchatdate).toLocaleString()}
                                                                    </p>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex shrink-0 items-center gap-x-6">
                                                    <div className="hidden sm:flex sm:flex-col sm:items-end">
                                                        <p className="text-sm/6 text-gray-900">{RequestStatus[request.requeststatus]}</p>
                                                        {
                                                            request.created_at ?
                                                                <p className="mt-1 text-xs/5 text-gray-500">
                                                                    建立時間 {new Date(request.created_at).toLocaleString()}
                                                                </p>
                                                                :
                                                                <></>
                                                        }
                                                        {
                                                            request.request_ai_consult_details?.startchatdate ?
                                                                <p className="mt-1 text-xs/5 text-gray-500">
                                                                    開始使用時間 {new Date(request.request_ai_consult_details?.startchatdate).toLocaleString()}
                                                                </p>
                                                                :
                                                                <></>
                                                        }
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </InfiniteScroll>


                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>

            {/* </Protect > */}
        </div >

    )
}
